import { render, staticRenderFns } from "./AdminProdIncident.vue?vue&type=template&id=79429c84&"
import script from "./AdminProdIncident.vue?vue&type=script&lang=js&"
export * from "./AdminProdIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports